import React, { useState, useEffect } from 'react';
import { Spin } from 'antd'
import _ from 'lodash'
import { Redirect, Route } from 'react-router-dom'
import * as utils from '../utils'
import "./index.css"
import { useHistory } from 'react-router-dom';

const PrivateRoute: React.FC<any> = ({ component: Component, exact, path }) => {
  const [session, setSession] = useState<any>(null)
  const history = useHistory()
  useEffect(() => {
    utils.getSession().then(response => {
      console.log("In the Private route component, fetched the session successfully, response :: ", response)
      setSession(_.cloneDeep(response))
    }).catch(err => {
      console.log("Erorr in fetching session data :: ", err)
      setSession({ error: "Session not found" })
      history.push("/login")
    })
  }, [history])
  console.log("session data in private route :: ", session)
  if (session?.username) {
    return (
      <Route path={path} exact={exact} render={(props) => <Component {...props} />} />
    )
  } else if (session?.error) {
    return (
      <Route path={path} exact={exact} render={(props) => <Redirect to={{ pathname: "/login" }} />} />
    )
  } else {
    return (
      <div className='center'>
        <Spin />
      </div>
    )
  }

}

export default PrivateRoute;